import { useParams, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const OwnerRoute = ({ children }) => {
	const { experienceSlug } = useParams()
	const currentExperience = useSelector(
		(state) => state.experience.experienceDetails
	)
	const userPosition = useSelector((state) => state.experience.userPosition)
	const orgRole = useSelector((state) => state.org.orgRole)
	const userType = useSelector((state) => state.user.authUser?.userType)

	if (!currentExperience || !userPosition) return <p>Loading...</p>

	const isOwner =
		(currentExperience.slug === experienceSlug &&
			userPosition.level === 'owner') ||
		orgRole === 'admin' ||
		userType === 'superAdmin'

	return isOwner ? children : <Navigate to='/' replace />
}

export default OwnerRoute
